
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 64 64","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M0 21.516v21.333h14.222L32 60.627V3.737L14.222 21.517zM64 32c0 15.268-10.693 28.039-24.999 31.232v-2.053C52.193 58.025 62 46.158 62 32c0-14.158-9.807-26.025-22.999-29.179V.768C53.307 3.961 64 16.732 64 32z"}}),_c('path',{attrs:{"d":"M53 32c0 9.143-5.843 16.921-13.999 19.805v-2.136C46.03 46.88 51 40.02 51 32s-4.97-14.881-11.999-17.669v-2.136C47.157 15.08 53 22.857 53 32z"}})])])
          )
        }
      }
    